module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "coupon",
      "data-spider": "coupon_list"
    }
  }, [(!_vm.errorConfig.show && _vm.winnerRecord) ? _c('div', [_c('ul', _vm._l((_vm.winnerRecord.data), function(item, index) {
    return (item.awardType === 2) ? _c('li', {
      attrs: {
        "data-spider": ""
      },
      on: {
        "click": function($event) {
          _vm.use(item.features.coupon.shopId, item.features.coupon.couponId, item.features.coupon.type, $event)
        }
      }
    }, [_c('div', {
      staticClass: "coupon-left"
    }, [_c('p', [_c('span', [_vm._v("¥")]), _vm._v(_vm._s(_vm._f("money")(item.features.coupon.reduce)))]), _vm._v(" "), _c('span', [_vm._v("满" + _vm._s(_vm._f("money")(item.features.coupon.full)) + "元可用")])]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right"
    }, [_c('p', [_vm._v("中奖时间：" + _vm._s(_vm._f("time")(item.gmtCreated)))]), _vm._v(" "), _c('span', [_vm._v("立即使用")])])]) : _vm._e()
  })), _vm._v(" "), (_vm.winnerRecord.data.length > 0) ? _c('p', {
    staticClass: "end"
  }, [_vm._v("～奖品已经看完了～")]) : _vm._e(), _vm._v(" "), (_vm.noRecord) ? _c('p', {
    staticClass: "no-record"
  }, [_vm._v("～暂无奖品，再接再厉！～")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('vm-error', {
    attrs: {
      "config": _vm.errorConfig
    }
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-loader/lib/template-compiler.js?id=data-v-3e179b97!../~/vue-loader/lib/selector.js?type=template&index=0!./components/vue/coupon.vue
 ** module id = 172
 ** module chunks = 3
 **/